import { useTranslation } from "react-i18next";
import OutlinedButton from "../../../../../components/common/OutlinedButton";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../../setup/constants";
import {
  ESenderRole,
  IContractDetailsResponseData,
} from "../../../../../setup/api/services/contract/models";
import PrimaryButton from "../../../../../components/common/PrimaryButton";
import { useMemo, useState } from "react";
import { isValidSaudiPhoneNumber } from "../../../../../setup/util/phoneNumber.helpers";
import { publishExternalDraftContract } from "../../../../../setup/api/services/contract";
import Spinner from "../../../../../components/common/Spinner";
import { AuthConfig } from "../../../../../setup/context/config/authConfig";

interface DraftActionsProps {
  milestone: IContractDetailsResponseData;
}

const DraftActions = ({ milestone }: DraftActionsProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authorities = AuthConfig.getUserInfo()?.authorities;
  const [loading, setLoading] = useState(false);

  const isPublishDisabled = useMemo(() => {
    const customerParties = milestone?.parties?.filter(
      (party) => party?.role === "CUSTOMER"
    );
    const providerParties = milestone?.parties?.filter(
      (party) => party?.role === "PROVIDER" || party?.role === "BROKER"
    );

    const customerSum = customerParties?.reduce(
      (acc, curr) => acc + (curr?.amount || 0),
      0
    );
    const providerSum = providerParties?.reduce(
      (acc, curr) => acc + (curr?.amount || 0),
      0
    );

    return (
      !milestone ||
      customerParties?.length === 0 ||
      providerParties?.length === 0 ||
      Number(customerSum).toFixed(2) !== Number(providerSum).toFixed(2) ||
      loading ||
      milestone?.parties?.some(
        (party) =>
          !isValidSaudiPhoneNumber(party?.phoneNumber || "") &&
          party?.role !== ESenderRole.BROKER
      )
    );
  }, [milestone, loading]);

  const handleEdit = () => {
    navigate(
      ROUTES.CREATE_COMPLEX_CONTRACT?.replace(
        ":complexId?",
        milestone?.parentId || ""
      ).replace(":milestoneId?", milestone.id || ""),
      { replace: true }
    );
  };

  const handlePublish = async () => {
    try {
      setLoading(true);

      if (milestone?.id) {
        await publishExternalDraftContract(milestone?.id);
      }

      setLoading(false);
      window?.location?.reload();
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <>
      {(authorities?.includes("CLIENT_ADMIN_UPDATE_CONTRACT") ||
        authorities?.includes("CLIENT_ADMIN") ||
        authorities?.includes("ORGANIZATION_OWNER")) && (
          <OutlinedButton
            style={{
              width: "129px",
              height: "40px",
              borderRadius: "8px",
              borderColor: "#e2e5ee",
              textAlign: "center",
              whiteSpace: "nowrap",
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: 500,
              color: "black",
            }}
            onClick={handleEdit}>
            <img
              src="/assets/images/svg/edit.svg"
              alt="edit"
              style={{
                width: "18px",
                height: "18px",
                marginLeft: "8px",
              }}
            />
            {t("lbl_edit")}
          </OutlinedButton>
        )}
      <PrimaryButton
        disabled={isPublishDisabled}
        onClick={handlePublish}
        style={{
          width: "171px",
          height: "40px",
          borderRadius: "8px",
          textAlign: "center",
          whiteSpace: "nowrap",
          fontSize: "14px",
          lineHeight: "100%",
          fontWeight: 500,
          background: isPublishDisabled ? "#E2E5EE" : "#0D44AD",
        }}>
        {loading ? <Spinner /> : t("lbl_publish")}
      </PrimaryButton>
    </>
  );
};

export default DraftActions;
